import { Injectable } from '@angular/core';

/**
 * Only on instance must exist in context
 * this service is declared in the shared module but
 * it will be used by the entire application
 */
@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  public inProgress = false;

  constructor() {
  }
}
